import React from "react";
import styled from "@emotion/styled";
import { PrimaryButton } from "../../Button";
import PropTypes from "prop-types";
import { is } from "../thunk";
import { doOrder } from "../../Order";
import { useDispatch, useSelector } from "react-redux";
import { customerBillingAddress } from "../../Customer";
import { setSelectedPaymentMethod } from "../action";
import { PAYMENT_TYPES } from "../constant";
import { isLoadingSelector } from "ccui-framework";
import { Icon } from "ccui-framework";

const Button = styled(PrimaryButton)`
  width: 300px;
  padding: 10px 20px;
  margin: 2rem auto 0.5rem;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
`;

const FormatSelectedOptionButton = ({ selectedMethod }) => {
  const dispatch = useDispatch();
  const billingDetails = useSelector(customerBillingAddress);
  const isRemoteLoading = useSelector(isLoadingSelector);
  const processOrder = (e) => {
    e.preventDefault();
    dispatch(setSelectedPaymentMethod(selectedMethod));
    dispatch(doOrder(billingDetails));
  };

  if (isRemoteLoading) {
    return (
      <Button>
        <Icon name="fa-spinner" />
      </Button>
    );
  }

  if (is(selectedMethod.paymentMethod, PAYMENT_TYPES.ACH_BULK)) {
    return (
      <Button onClick={processOrder}>
        Get Paid with ACH ending in {selectedMethod.account.slice(2)}
      </Button>
    );
  }

  if (is(selectedMethod.paymentMethod, PAYMENT_TYPES.MAILCHECK_BULK)) {
    return <Button onClick={processOrder}>Get Paid by Mail Check</Button>;
  }

  if (is(selectedMethod.paymentMethod, PAYMENT_TYPES.PAYPAL_ACCOUNT_BULK)) {
    return (
      <Button onClick={processOrder}>
        Get Paid with PayPal <br /> Account: {selectedMethod.paypalAccountEmail}
      </Button>
    );
  }

  return null;
};

FormatSelectedOptionButton.prototype = {
  selectedMethod: PropTypes.object.isRequired,
};

export { FormatSelectedOptionButton };
